import { LoadingMascot } from '@webbuilder/ui'

/**
 * La pantalla de arranque: la mascota girando, centrada, sobre el fondo del tema.
 *
 * Es lo que se ve mientras la aplicación todavía no sabe qué enseñar — si hay
 * sesión, a dónde lleva un traspaso entre orígenes, si esta cuenta tiene
 * proyectos. Su trabajo no es entretener: es NO decidir en voz alta. Cualquier
 * otra cosa en ese hueco es una respuesta, y las respuestas dadas antes de
 * tiempo se desdicen solas un segundo después.
 *
 * Sin `ThemeContext` y con el tema por prop: dos de sus tres usos ocurren antes
 * de que el proveedor exista, que es justo el momento que esta pantalla cubre.
 *
 * La misma mascota que el editor y que las listas del panel. Uno de estos tres
 * momentos es precisamente el traspaso al editor —«Redirigiendo»—, así que sin
 * compartirla el cruce entre las dos aplicaciones cambiaba de indicador a mitad
 * de camino.
 */
export function BootScreen({ theme, children }: { theme: string; children?: React.ReactNode }) {
  return (
    <div style={{
      width: '100vw', height: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: theme === 'dark' ? '#242424' : '#FFFFFF', fontFamily: "'DM Sans', sans-serif",
      // La mascota toma el gris apagado del tema, no su color por defecto.
      ['--vl-mascot-color' as string]: theme === 'dark' ? 'rgba(255,255,255,0.34)' : 'rgba(24,24,27,0.28)',
    } as React.CSSProperties}>
      {children ?? <LoadingMascot spinning size={56} />}
    </div>
  )
}
